import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/Bits";
import { Search, Phone, BadgeCheck } from "lucide-react";

export default function Members() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/members").then((r) => setList(r.data)); }, []);

  const filtered = list.filter((m) => !q || [m.name, m.enrollment_no, m.specialization, m.chamber_no].join(" ").toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="members-page">
      <PageHeader title="Bar Directory" subtitle="A directory of the advocate members of the Association." />
      <section className="max-w-6xl mx-auto px-4 py-14">
        <div className="flex items-center justify-between gap-4 mb-6 flex-wrap">
          <p className="text-sm text-[#5A6270]">{filtered.length} member(s)</p>
          <div className="relative">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8A6320]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, enrolment, specialization..."
              className="pl-9 pr-4 py-2 rounded-full border border-[#E5DECF] text-sm w-72 max-w-full focus:outline-none focus:border-[#E6C687]" data-testid="member-search" />
          </div>
        </div>
        <div className="card-elite rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#0B2E63] text-[#f0e4c6] text-left">
                <th className="px-4 py-3 font-semibold">Advocate</th>
                <th className="px-4 py-3 font-semibold hidden sm:table-cell">Enrolment No.</th>
                <th className="px-4 py-3 font-semibold hidden md:table-cell">Chamber</th>
                <th className="px-4 py-3 font-semibold">Specialization</th>
                <th className="px-4 py-3 font-semibold">Contact</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((m, i) => (
                <tr key={m.id} className={`border-t border-[#F0E9DA] ${i % 2 ? "bg-[#FCFAF5]" : "bg-white"}`} data-testid={`member-${m.id}`}>
                  <td className="px-4 py-3 font-medium text-[#2a2422] flex items-center gap-2"><BadgeCheck size={15} className="text-[#8A6320]" /> {m.name}</td>
                  <td className="px-4 py-3 text-[#5A6270] hidden sm:table-cell">{m.enrollment_no}</td>
                  <td className="px-4 py-3 text-[#5A6270] hidden md:table-cell">{m.chamber_no}</td>
                  <td className="px-4 py-3 text-[#5A6270]">{m.specialization}</td>
                  <td className="px-4 py-3">
                    {m.phone ? <a href={`tel:${m.phone.replace(/\s/g, "")}`} className="text-[#123B7A] font-medium flex items-center gap-1"><Phone size={13} /> {m.phone}</a> : "—"}
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-[#5A6270]">No members found.</td></tr>}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
